<template lang="pug">
    div.draggable(v-if="elements && elements.length")
        draggable(v-model="elements" @end="onEnd")
            transition-group( name="flip-list" tag="div")
                div.draggableItem(v-for="element in elements" :key="keyValue && element[keyValue] ? element[keyValue] : `${element}-key`")

                    // Symbol name
                    div(v-if="typeof element === 'string'") {{ withDictionary ? dictionary[element].name : element}}
                    div(v-else) {{keyValue && element[keyValue] ? element[keyValue] : element[0] }}

                    // Draggable icon
                    div
                        span.cursor-pointer(@click="deleteElement(element)")
                            v-icon(color="red") delete

                        span
                            v-icon unfold_more
</template>

<script>
    import VueTypes from 'vue-types';
    import draggable from 'vuedraggable';

    export default {
        components: {
            draggable,
        },
        props: {
            items: VueTypes.array.def([]),
            callBackFunction: VueTypes.func.def(() => {}),
            dictionary: VueTypes.object.def({}),
            keyValue: VueTypes.string.def(''),
        },
        data() {
            return {
                elements: this.items,
            };
        },
        computed: {
            withDictionary() {
                return this.dictionary && Object.keys(this.dictionary).length;
            },
        },
        watch: {
            items(val) {
                this.elements = val;
            },
        },
        methods: {
            /**
             * Return sorted items in callback function
             */
            onEnd() {
                this.callBackFunction(this.elements);
            },
            deleteElement(element) {
                this.elements = this.elements.filter(
                    (item) => element !== item
                );
                this.callBackFunction(this.elements);
            },
        },
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl"

    .draggableItem
        display: flex
        justify-content: space-between
        align-items: center
        margin: 8px 0
        padding: 5px 10px
        border: 1px solid rgba($theme.grey, 0.8)
        border-radius: 5px
        transition: border-color .3s
        background: $theme.white

        &:hover
            cursor: pointer
            box-shadow: 0 0 3px rgba(0, 0, 0, 0.1)
            border-color: rgba($theme.primary, 0.5)
</style>
